"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKeyActions = void 0;
var _react = require("react");
var useKeyActions = exports.useKeyActions = function useKeyActions(_ref) {
  var disabled = _ref.disabled,
    onFocus = _ref.onFocus,
    onSelectFocusedOption = _ref.onSelectFocusedOption;
  return (0, _react.useCallback)(function (event) {
    if (disabled) return;
    switch (event.key) {
      case 'Enter':
        if (event.keyCode === 229) {
          // ignore the keydown event from an Input Method Editor(IME)
          // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
          break;
        }
        onSelectFocusedOption();
        break;
      case 'ArrowUp':
        onFocus('up');
        break;
      case 'ArrowDown':
        onFocus('down');
        break;
      case 'Home':
        onFocus('first');
        break;
      case 'End':
        onFocus('last');
        break;
      default:
        return;
    }
    event.preventDefault();
  }, [onFocus, onSelectFocusedOption, disabled]);
};